<template>
  <div class="text-block block-card card-border big-card-block ">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <v-icon class="white--text">email</v-icon>
            </div>

            <h4>
              Email 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount">
          <div class="block-card-body" v-if="validData">
            <label for="">To</label>
            <vTextareaAutocomplete 
              v-model="data.to" 
              :type="'textfield'"
              :validation-rules="requireRules"/>

            <label >CC</label>
            <vTextareaAutocomplete 
              v-model="data.cc" 
              :type="'textfield'"
              />

            <label >BCC</label>
            <vTextareaAutocomplete 
              v-model="data.bcc" 
              :type="'textfield'"
              />

            <v-layout 
              row 
              wrap 
              class="align-center">
              <v-flex 
                xs9 
                class="pa-0">
                <label >Subject</label>
                <vTextareaAutocomplete 
                  v-model="data.subject" 
                  :type="'textfield'" 
                  :validation-rules="requireRules"/>
              </v-flex>
              <v-flex xs3>
                <v-switch 
                  v-model="data.useTemplate" 
                  label="Use Template"/>
              </v-flex>
            </v-layout>

            <label>Body</label>
            <editor 
              v-if="!data.useTemplate"
              id="d1"
              plugins="lists code"
              v-model="data.bodyText"
            />
            <v-autocomplete
              v-else
              :items="variables"
              v-model="data.bodyAttributes"
              :error="data.bodyAttributes && data.bodyAttributes.length < 0"
              :error-messages="data.bodyAttributes && data.bodyAttributes.length < 0? 'Attribute is Required':'' "
              item-text="variable"
              class="left-radius"
              item-value="variable"
              outline
              chips
              multiple
              solo
            >
              <template v-slot:selection="dataList">
                <v-chip
                  :selected="dataList.selected"
                  close
                  color="#333"
                  @input="data.bodyAttributes.splice(data.bodyAttributes.indexOf(dataList.item.variable), 1)"
                >
                  <strong>{{ dataList.item.variable }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-autocomplete>

          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import FormValidation from '../FormValidation'
import Editor from '@tinymce/tinymce-vue'
export default {
  name: 'CardEmail',
  components: {
    Editor,
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      tinyOptions: {
        height: 700,
        plugins: 'code',
        toolbar: 'code',
      },
      requireRules: [v => !!v || 'Field is required']
    }
  },

  computed: {
    variables() {
      return this.$store.state.blocksBuild.variables
    }
  },
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {}
}
</script>

<style>
.tox-notifications-container {
  display: none;
}
</style>
